import React from "react";
import { ProductConsumer } from "../../../Context/AddProWakel";
import NumberFormat from "react-number-format";
import { filterKogaRows, sumKogaRows } from "../../../util/kogaReport";

const FooterOfRaportKoga = () => {
  return (
    <>
      <ProductConsumer>
        {(value) => {
          const { JM_dataRaportyKoga, JM_name, JM_code } = value;
          // Sum exactly the rows the table above is showing, so the footer
          // follows the "ماوە" / "نەماوە" buttons, the search boxes, deletes
          // and a warehouse restart without a separate recalculation step.
          const { cartons, money } = sumKogaRows(
            filterKogaRows(JM_dataRaportyKoga, JM_name, JM_code)
          );
          return (
            <>
              {/* second row */}
              <div className="row">
                <div className="col-12">
                  <div className="row ">
                    <div className="col-lg-2 col-6">
                      <h4 className="bg-white tc mt3 py-2">
                        <NumberFormat
                          value={cartons}
                          thousandSeparator={true}
                          displayType="text"
                        />
                      </h4>
                    </div>
                    <div className="col-lg-4 col-6 py-3">
                      <h4 className="text-warning tc font-weight-bold ">
                        ڕەسیدی کۆتایی هەموو کارتۆنەکان
                      </h4>
                    </div>

                    <div className="col-lg-2 col-6">
                      <h4 className="bg-white tc mt3 py-2">
                        <NumberFormat
                          value={money}
                          thousandSeparator={true}
                          displayType="text"
                        />
                      </h4>
                    </div>
                    <div className="col-lg-4 col-6 py-3">
                      <h4 className="text-warning tc font-weight-bold ">
                        {" "}
                        $ڕەسیدی کۆتایی هەموو پارەکان
                      </h4>
                    </div>
                  </div>
                </div>
              </div>

              {/* third row */}
              <div className="row">
                <div className="col-lg10 col-12"></div>
              </div>
            </>
          );
        }}
      </ProductConsumer>
    </>
  );
};

export default FooterOfRaportKoga;
